import { ActorType, AuditPolicy, AuthenticationAssuranceLevel, ConcurrencyPolicy, IdempotencyPolicy, PrivacyClassification, ScopeType, } from './operation.js';
import * as OID from './operation-ids.js';
export const ORGANIZATION_REGULATORY_PROFILE_OPERATIONS = {
    [OID.ORGANIZATION_REGULATORY_PROFILE_READ]: {
        id: OID.ORGANIZATION_REGULATORY_PROFILE_READ,
        name: 'Read Organization Regulatory Profile',
        implementationStatus: 'AVAILABLE',
        labelKey: 'operations.organization.regulatory-profile.read.label',
        descriptionKey: 'operations.organization.regulatory-profile.read.description',
        permission: 'organization:profile:read',
        permissionId: 'organization:profile:read',
        module: 'ADMIN',
        requiredModules: ['ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.ORGANIZATION, ScopeType.BRANCH],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH'],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        forcesClientScope: false,
        clientForcing: 'NONE',
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'organization.regulatory-profile.read',
        allowedActorTypes: [ActorType.USER],
        allowedPersonas: ['ORG_ADMIN'],
        accessType: 'READ',
        delegationPolicy: 'NOT_ALLOWED',
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ORGANIZATION_REGULATORY_PROFILE_UPDATE]: {
        id: OID.ORGANIZATION_REGULATORY_PROFILE_UPDATE,
        name: 'Update Organization Regulatory Profile',
        implementationStatus: 'AVAILABLE',
        labelKey: 'operations.organization.regulatory-profile.update.label',
        descriptionKey: 'operations.organization.regulatory-profile.update.description',
        permission: 'organization:profile:update',
        permissionId: 'organization:profile:update',
        module: 'ADMIN',
        requiredModules: ['ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.ORGANIZATION, ScopeType.BRANCH],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH'],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        forcesClientScope: false,
        clientForcing: 'NONE',
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: 'organization.regulatory-profile.update',
        allowedActorTypes: [ActorType.USER],
        allowedPersonas: ['ORG_ADMIN'],
        accessType: 'ADMIN',
        delegationPolicy: 'NOT_ALLOWED',
        httpMethods: ['PATCH'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
};
